// test101
(101 && 0);
